import React from 'react'
import { IoReorderThreeOutline } from 'react-icons/io5'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

import { setOpenSidebar } from '../api/features/sidebarSlice'
import Logo from '../assets/images/protocol.ico'
import { ReturnReceiptReminderIconButton, ReturnReceiptReminderProvider } from '../components/files/ReturnReceiptReminderWidget'
import HelpdeskNotificationsDropdown from '../components/helpdesk/HelpdeskNotificationsDropdown'
import LanguageSwitcher from '../components/other/LanguageSwitcher'
import UserMenu from '../components/other/UserMenu'
import useHelpdeskSocket from '../hooks/useHelpdeskSocket'
import { useIsStaleCompanyEntry } from '../hooks/useIsStaleCompanyEntry'
import { getLandingRoute } from '../utils/landingRoute'
import MobileSidebar from './MobileSidebar'
import Navbar from './Navbar'
import PageWrapper from './PageWrapper'
import Sidebar from './Sidebar'

export default function Layout() {
  const dispatch = useDispatch()
  const { openSidebar } = useSelector((state) => state.sidebar)
  const user = useSelector((state) => state.user.user)
  const company = useSelector((state) => state.company.company)

  useHelpdeskSocket()

  const isStaleEntry = useIsStaleCompanyEntry(company?.id)

  const handleSetOpen = () => {
    dispatch(setOpenSidebar(!openSidebar))
  }

  // Browser Back/Forward into a page opened before the company was switched
  if (isStaleEntry) return <Navigate to={getLandingRoute(user?.functions) ?? '/homepage'} replace />

  return (
    <ReturnReceiptReminderProvider>
      <div className="lg:hidden relative">
        {/* relative: on phones UserMenu's dropdown aligns to the header's right edge */}
        <div className="relative flex items-center justify-between bg-[#006EAB] px-6 py-3">
          <img src={Logo} className="duration-500 h-8 w-8" alt="Logo" />
          <div className="flex items-center gap-1.5">
            <ReturnReceiptReminderIconButton light />
            <UserMenu light />
            <LanguageSwitcher light />
            {user?.token ? <HelpdeskNotificationsDropdown light /> : null}
            <span className="flex h-9 w-9 items-center justify-center" onClick={handleSetOpen}>
              <IoReorderThreeOutline className="text-white" size={22} />
            </span>
          </div>
        </div>
        {openSidebar && <div className="fixed inset-0 bg-black opacity-75 z-10" onClick={handleSetOpen}></div>}
        <MobileSidebar openSidebar={openSidebar} />
        <div className={`transition-transform duration-300 ${openSidebar ? 'overflow-hidden' : ''}`}>
          <PageWrapper>
            <Outlet />
          </PageWrapper>
        </div>
      </div>
      <div className="hidden lg:flex items-start justify-start max-h-screen overflow-hidden">
        <Sidebar />

        <div className="w-full flex flex-col justify-center items-start">
          <div className="w-full flex justify-center items-center">
            <div className="w-[90%]">
              <Navbar />
            </div>
          </div>
          <PageWrapper>
            <Outlet />
          </PageWrapper>
        </div>
      </div>
    </ReturnReceiptReminderProvider>
  )
}
